import { TranslationKeys } from '@pascal/pascal-core';

/**
 * @enum {string}
 * @type {Object<string, string>}
 */
export const TKeys = Object.assign(TranslationKeys, {
  TopWins: 'TOP_WINNERS',
  History: 'RESULT_HISTORY',
  Result: 'RESULT',
  Bet: 'BET',
  Info: 'INFO',
  RoundId: 'ROUND_ID',
  Odd: 'ODD',
  Id: 'ID',
  KEY: 'KEY',
  SALT: 'SALT',
  CHECK: 'CHECK',
  HASH_CODE: 'HASH_CODE',
  FreeSpinsAreActivated: 'FREE_SPINS_ARE_ACTIVATED',
  FreeSpinCount: 'FREE_SPIN_COUNT',
  BetCanceled: 'BET_CANCELED',
  YourBetIsAccepted: 'YOUR_BET_IS_ACCEPTED',
  NotEnoughBalance: 'NOT_ENOUGH_BALANCE',
  CheckHashCode: 'CHECK',
  Spin: 'SPIN',
  Stop: 'STOP',
  FAIRNESS_P1: 'FAIRNESS_P1',
  FAIRNESS_P2: 'FAIRNESS_P2',
  FAIRNESS_P3: 'FAIRNESS_P3',
  FAIRNESS_P4: 'FAIRNESS_P4',
  FAIRNESS_P5: 'FAIRNESS_P5',
  FAIRNESS_P6: 'FAIRNESS_P6',
  FAIRNESS_P7: 'FAIRNESS_P7',
  FAIRNESS_P8: 'FAIRNESS_P8',
  FAIRNESS_P9: 'FAIRNESS_P9',
  FAIRNESS_P10: 'FAIRNESS_P10',
  FAIRNESS_P11: 'FAIRNESS_P11',
  FAIRNESS_P12: 'FAIRNESS_P12',
  GameInfo: 'GAME_INFO',
  Refresh: 'REFRESH',
  Connecting: 'CONNECTING',
  ConnectionLost: 'CONNECTION_LOST',
  PleaseRefresh: 'PLEASE_REFRESH',
  Bonus: 'BONUS',
  InvalidToken: 'INVALID_TOKEN',
  InvalidAmount: 'INVALID_AMOUNT',
  BuyBonusDisabled: 'BUY_BONUS_DISABLED',
  PartnerNotFound: 'PARTNER_NOT_FOUND',
  UnHandledError: 'UN_HANDLED_ERROR',
  NoWin: 'NO_WIN',
  WinningBet: 'WINNING_BET',
  NextRound: 'NEXT_ROUND',
  LimitExceeded: 'LIMIT_EXCEEDED',
})